import { Component, OnInit} from '@angular/core';
import { HtmlPagesLinksService } from 'app/modules/shared/services/html-pages-links.service';


@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss'],
    standalone: false
})
export class PrivacyPolicyComponent implements OnInit {
  privacyPolicyData;
  constructor(private htmlPagesLinksService: HtmlPagesLinksService) { }

  ngOnInit() {
    this.getPrivacyPolicyData();
  }

  getPrivacyPolicyData() {
    this.htmlPagesLinksService.getPrivacyPolicy().subscribe(result => {
      this.privacyPolicyData = result;
    });
  }
}
